import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function headerCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'headerCell',
    baseStyle: {
      border: 'none',
      padding: `${theme.space['s']} ${theme.space['xs']}`,
      color: theme.colors.muted,
      fontWeight: 600
    }
  };
}
